<template>
  <Titulo texto="Título de mi Blog" />
  <!--<button @click="getPosts" type="button">Traer Posts</button>-->
  <hr />

  <ul>
        <li v-for="post in posts" :key="post.id">
            <router-link :to="`/blog/${post.id}`">{{ post.title }}</router-link>
        </li>
  </ul>
</template>

<script>
import Titulo from '../components/Titulo'
export default {
    components: {
        Titulo,
    },
    data() {
        return {
            posts: []
        }
    },
    methods: {
        async getPosts() {
            try {
                this.posts = []
                const data = await fetch('https://jsonplaceholder.typicode.com/posts')
                const posts = await data.json()

                this.posts = await posts
            } catch (error) {
                console.log(error)
            }
        
        }
    },
    created () {
        this.getPosts();
    },
}
</script>

<style>

</style>